module.exports = __webpack_public_path__ + "img/48_21.e76e88c7.png";